import { useAuthStore } from "../store/authStore";
import { Navigate } from "react-router-dom";

export function BoardScreen() {
  const me = useAuthStore((s) => s.me);
  const allowed = me?.org.type === "fleet" || me?.plan.planId === "fleet";
  if (!allowed) return <Navigate to="/check" replace />;
  return (
    <div className="stack">
      <h1 className="screen-title">Board</h1>
      <div className="card">
        <p className="muted">
          To pick loads from a load board, take a screenshot of the board and add it on Check.
        </p>
      </div>
    </div>
  );
}
